import { action } from 'satcheljs';

export let onShowCalendarSharingPermissionsDialog = action(
    'onShowCalendarSharingPermissionsDialog'
);
